/* ===========================================
   MBUR CANDLE CO — Loyalty Program JS
   =========================================== */

(function() {
  'use strict';

  /* ---- Config (set via Liquid in the snippet) ---- */
  var LOYALTY_SCRIPT_URL = window.__loyaltyScriptUrl || '';
  var CUSTOMER_EMAIL = window.__customerEmail || '';
  var CUSTOMER_NAME = window.__customerName || '';
  var SHOP_URL = window.__shopUrl || '';

  /* ---- Tier & Reward config (loaded from Google Sheet Config tab) ---- */
  var TIERS = [];
  var REWARDS = [];

  function applyConfig(config) {
    if (config && config.tiers && config.tiers.length > 0) {
      TIERS = config.tiers;
    }
    if (config && config.rewards && config.rewards.length > 0) {
      REWARDS = config.rewards;
    }
  }

  /* Fallback emoji icons (used when no icon_url is set in Google Sheet Config) */
  var REWARD_ICONS = {
    discount: '&#127991;',
    gift_card: '&#127873;',
    giveaway: '&#127922;',
    free_product: '&#127873;',
    manual: '&#11088;'
  };

  /* Build icon HTML — uses <img> if icon_url exists in config, otherwise emoji */
  function rewardIconHtml(reward) {
    if (reward.icon_url) {
      return '<img class="loyalty-redeem__icon-img" src="' + reward.icon_url + '" alt="" width="28" height="28">';
    }
    return REWARD_ICONS[reward.type] || REWARD_ICONS.manual;
  }

  /* ---- Helpers ---- */
  function getTier(points) {
    if (TIERS.length === 0) return { name: 'Member', min: 0, multiplier: 1 };
    var tier = TIERS[0];
    for (var i = TIERS.length - 1; i >= 0; i--) {
      if (points >= TIERS[i].min) { tier = TIERS[i]; break; }
    }
    return tier;
  }

  function getNextTier(points) {
    for (var i = 0; i < TIERS.length; i++) {
      if (points < TIERS[i].min) return TIERS[i];
    }
    return null;
  }

  function formatDate(dateStr) {
    var d = new Date(dateStr);
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return months[d.getMonth()] + ' ' + d.getDate();
  }

  /* ---- API calls ---- */
  function fetchBalance(email, callback) {
    if (!LOYALTY_SCRIPT_URL || !email) { callback(null); return; }
    fetch(LOYALTY_SCRIPT_URL + '?action=balance&email=' + encodeURIComponent(email))
      .then(function(r) { return r.json(); })
      .then(callback)
      .catch(function() { callback(null); });
  }

  function redeemPoints(email, points, callback) {
    if (!LOYALTY_SCRIPT_URL) { callback(null); return; }
    fetch(LOYALTY_SCRIPT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'redeem', email: email, points: points })
    })
      .then(function(r) { return r.json(); })
      .then(callback)
      .catch(function() { callback(null); });
  }

  function registerReferral(email, referralCode) {
    if (!LOYALTY_SCRIPT_URL || !referralCode) return;
    fetch(LOYALTY_SCRIPT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'signup', email: email, name: CUSTOMER_NAME, referred_by: referralCode })
    }).catch(function() {});
  }

  function postBackfill(email, name, orders, callback) {
    if (!LOYALTY_SCRIPT_URL || !email || !orders || orders.length === 0) {
      callback(null);
      return;
    }
    fetch(LOYALTY_SCRIPT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'backfill',
        email: email,
        name: name,
        orders: orders
      })
    })
      .then(function(r) { return r.json(); })
      .then(callback)
      .catch(function() { callback(null); });
  }

  /* ---- Account Page: Loyalty Dashboard ---- */
  function renderDashboard(container, data) {
    if (!data || data.error) {
      container.innerHTML = '<div class="loyalty-dashboard__loading">Unable to load rewards. Please refresh the page.</div>';
      return;
    }

    var points = data.points || 0;
    var tier = getTier(points);
    var nextTier = getNextTier(points);
    var referralCode = data.referral_code || '';
    var activity = data.activity || [];
    var referralUrl = SHOP_URL + '/account/register?ref=' + referralCode;

    /* Progress to next tier */
    var progressPct = 100;
    var progressText = 'You\'ve reached the highest tier!';
    if (nextTier) {
      progressPct = Math.min(100, Math.round((points / nextTier.min) * 100));
      progressText = (nextTier.min - points) + ' pts to ' + nextTier.name;
    }

    var html = '';

    /* Stats row */
    html += '<div class="loyalty-stats">';

    /* Points card */
    html += '<div class="loyalty-stat-card">';
    html += '  <p class="loyalty-stat-card__value">' + points.toLocaleString() + '</p>';
    html += '  <p class="loyalty-stat-card__label">Points Balance</p>';
    html += '</div>';

    /* Tier card */
    html += '<div class="loyalty-stat-card loyalty-stat-card--tier">';
    html += '  <p class="loyalty-stat-card__value">' + tier.name + '</p>';
    html += '  <p class="loyalty-stat-card__label">' + tier.multiplier + 'x points per $1</p>';
    html += '  <div class="loyalty-tier-progress">';
    html += '    <div class="loyalty-tier-bar"><div class="loyalty-tier-bar__fill" style="width:' + progressPct + '%"></div></div>';
    html += '    <p class="loyalty-tier-progress__text">' + progressText + '</p>';
    html += '  </div>';
    html += '</div>';

    /* Referral card */
    html += '<div class="loyalty-stat-card loyalty-stat-card--referral">';
    html += '  <p class="loyalty-stat-card__label">Refer & Earn</p>';
    html += '  <p class="loyalty-stat-card__value">' + referralCode + '</p>';
    html += '  <button class="loyalty-copy-btn js-copy-referral" data-url="' + referralUrl + '">Copy Link</button>';
    html += '</div>';

    html += '</div>'; /* end .loyalty-stats */

    /* Redeem section */
    html += '<div class="loyalty-redeem">';
    html += '  <p class="loyalty-redeem__title">Redeem Rewards</p>';
    html += '  <div class="loyalty-redeem__options">';
    for (var i = 0; i < REWARDS.length; i++) {
      var r = REWARDS[i];
      var canAfford = points >= r.points;
      var icon = rewardIconHtml(r);
      var typeClass = ' loyalty-redeem__btn--' + (r.type || 'discount');
      html += '    <button class="loyalty-redeem__btn js-redeem-btn' + typeClass + '" data-points="' + r.points + '" data-type="' + (r.type || 'discount') + '"' + (canAfford ? '' : ' disabled') + '>';
      html += '      <span class="loyalty-redeem__icon">' + icon + '</span>';
      html += '      <span class="loyalty-redeem__desc">' + r.description + '</span>';
      html += '      <span class="loyalty-redeem__pts">' + r.points + ' pts</span>';
      html += '    </button>';
    }
    html += '  </div>';
    html += '  <div class="js-redeem-result"></div>';
    html += '</div>';

    /* Activity log */
    if (activity.length > 0) {
      html += '<div class="loyalty-activity">';
      html += '  <p class="loyalty-activity__title">Recent Activity</p>';
      html += '  <ul class="loyalty-activity__list">';
      var shown = Math.min(activity.length, 8);
      for (var j = 0; j < shown; j++) {
        var a = activity[j];
        var ptsClass = (a.points < 0) ? ' loyalty-activity__pts--negative' : '';
        var sign = (a.points >= 0) ? '+' : '';
        html += '    <li class="loyalty-activity__item">';
        html += '      <span class="loyalty-activity__pts' + ptsClass + '">' + sign + a.points + ' pts</span>';
        html += '      <span class="loyalty-activity__desc">' + a.description + '</span>';
        html += '      <span class="loyalty-activity__date">' + formatDate(a.created_at) + '</span>';
        html += '    </li>';
      }
      html += '  </ul>';
      html += '</div>';
    }

    /* How to earn */
    var baseMult = (TIERS.length > 0) ? TIERS[0].multiplier : 1;
    html += '<div class="loyalty-earn">';
    html += '  <p class="loyalty-earn__title">How to Earn Points</p>';
    html += '  <div class="loyalty-earn__grid">';
    html += '    <div class="loyalty-earn__item"><span>Shop ($1 spent)</span><span>' + baseMult + ' pt</span></div>';
    html += '    <div class="loyalty-earn__item"><span>Leave a review</span><span>50 pts</span></div>';
    html += '    <div class="loyalty-earn__item"><span>Review with photos</span><span>100 pts</span></div>';
    html += '    <div class="loyalty-earn__item"><span>Refer a friend</span><span>100 pts</span></div>';
    html += '    <div class="loyalty-earn__item"><span>Friend\'s 1st purchase</span><span>200 pts</span></div>';
    html += '    <div class="loyalty-earn__item"><span>Sign up (referred)</span><span>50 pts</span></div>';
    html += '  </div>';
    html += '</div>';

    container.innerHTML = html;

    /* Bind events */
    bindDashboardEvents(container);
  }

  function bindDashboardEvents(container) {
    /* Copy referral link */
    var copyBtn = container.querySelector('.js-copy-referral');
    if (copyBtn) {
      copyBtn.addEventListener('click', function() {
        var url = this.getAttribute('data-url');
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url);
        } else {
          var ta = document.createElement('textarea');
          ta.value = url;
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }
        this.textContent = 'Copied!';
        this.classList.add('copied');
        var btn = this;
        setTimeout(function() {
          btn.textContent = 'Copy Link';
          btn.classList.remove('copied');
        }, 2000);
      });
    }

    /* Redeem buttons */
    var redeemBtns = container.querySelectorAll('.js-redeem-btn');
    var resultDiv = container.querySelector('.js-redeem-result');
    redeemBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var pts = parseInt(this.getAttribute('data-points'));
        var rewardType = this.getAttribute('data-type') || 'discount';

        /* Customize confirmation message per type */
        var confirmMsg = 'Redeem ' + pts + ' points for this reward?';
        if (rewardType === 'giveaway') confirmMsg = 'Spend ' + pts + ' points to enter this giveaway?';
        if (!confirm(confirmMsg)) return;

        /* Disable all buttons */
        redeemBtns.forEach(function(b) { b.disabled = true; });
        btn.querySelector('.loyalty-redeem__desc').textContent = 'Redeeming...';

        redeemPoints(CUSTOMER_EMAIL, pts, function(resp) {
          if (resp && resp.error) {
            resultDiv.innerHTML =
              '<div style="color:#A03232;font-size:13px;margin-top:12px;">' + resp.error + '</div>';
            redeemBtns.forEach(function(b) { b.disabled = false; });
            return;
          }

          if (!resp || !resp.success) {
            resultDiv.innerHTML =
              '<div style="color:#A03232;font-size:13px;margin-top:12px;">Something went wrong. Please try again.</div>';
            redeemBtns.forEach(function(b) { b.disabled = false; });
            return;
          }

          /* Show result based on reward type */
          if (resp.discount_code) {
            resultDiv.innerHTML =
              '<div class="loyalty-discount-code">' +
              '  <p class="loyalty-discount-code__label">Your discount code:</p>' +
              '  <p class="loyalty-discount-code__value">' + resp.discount_code + '</p>' +
              '  <p class="loyalty-discount-code__note">Use at checkout. Single use, no expiry.</p>' +
              '</div>';
          } else if (resp.message) {
            resultDiv.innerHTML =
              '<div class="loyalty-redeem-success">' +
              '  <p class="loyalty-redeem-success__icon">&#10003;</p>' +
              '  <p class="loyalty-redeem-success__msg">' + resp.message + '</p>' +
              '</div>';
          }

          /* Refresh dashboard after short delay */
          setTimeout(function() { initDashboard(); }, 2000);
        });
      });
    });
  }

  /* ---- Cart Banner ---- */
  function renderCartBanner(container, data) {
    if (!CUSTOMER_EMAIL) {
      /* Guest user - show login prompt */
      container.innerHTML =
        '<div class="loyalty-cart-banner">' +
        '  <div class="loyalty-cart-banner__row">' +
        '    <p class="loyalty-cart-banner__points">Earn rewards on this purchase</p>' +
        '    <a href="/account/login" class="loyalty-cart-banner__login">Sign in</a>' +
        '  </div>' +
        '</div>';
      return;
    }

    if (!data || data.error) {
      container.innerHTML = '';
      return;
    }

    var points = data.points || 0;
    var tier = getTier(points);

    /* Calculate points earning for this order */
    var cartCents = parseInt(container.getAttribute('data-cart-total') || '0');
    var cartDollars = Math.floor(cartCents / 100);
    var earning = Math.round(cartDollars * tier.multiplier);

    container.innerHTML =
      '<div class="loyalty-cart-banner">' +
      '  <div class="loyalty-cart-banner__row">' +
      '    <div>' +
      '      <p class="loyalty-cart-banner__points">You have <span>' + points.toLocaleString() + ' points</span></p>' +
      '      <p class="loyalty-cart-banner__earning">Earning <strong>+' + earning + ' pts</strong> on this order</p>' +
      '    </div>' +
      '    <span class="loyalty-cart-banner__tier">' + tier.name + '</span>' +
      '  </div>' +
      '</div>';
  }

  /* ---- Init ---- */
  function initDashboard() {
    var dashboard = document.getElementById('loyalty-dashboard-content');
    if (!dashboard || !CUSTOMER_EMAIL) return;

    dashboard.innerHTML = '<div class="loyalty-dashboard__loading">Loading your rewards...</div>';

    fetchBalance(CUSTOMER_EMAIL, function(data) {
      if (data && data.config) applyConfig(data.config);

      // Always check for uncredited orders (backend deduplicates, so this is safe)
      // This also handles future orders since there's no checkout script
      var customerOrders = window.__customerOrders || [];
      if (data && customerOrders.length > 0) {
        var ordersToBackfill = [];
        for (var i = 0; i < customerOrders.length; i++) {
          var o = customerOrders[i];
          var amount = parseFloat(o.amount);
          if (o.order_name && amount > 0) {
            ordersToBackfill.push({
              order_name: o.order_name,
              amount: amount,
              date: o.date
            });
          }
        }

        if (ordersToBackfill.length > 0) {
          dashboard.innerHTML = '<div class="loyalty-dashboard__loading">Calculating your rewards from past orders...</div>';

          postBackfill(CUSTOMER_EMAIL, CUSTOMER_NAME, ordersToBackfill, function(backfillResult) {
            // Re-fetch balance to get updated totals
            fetchBalance(CUSTOMER_EMAIL, function(updatedData) {
              if (updatedData && updatedData.config) applyConfig(updatedData.config);
              renderDashboard(dashboard, updatedData);

              // Show backfill notification if points were awarded
              if (backfillResult && backfillResult.total_points_awarded > 0) {
                showBackfillNotification(dashboard, backfillResult);
              }

              // Update order points column
              updateOrderPointsColumn(backfillResult);
            });
          });
          return;
        }
      }

      renderDashboard(dashboard, data);
      // Populate points column from activity data on return visits
      updateOrderPointsFromActivity(data);
    });
  }

  /* ---- Backfill helpers ---- */
  function showBackfillNotification(container, backfillResult) {
    var note = document.createElement('div');
    note.className = 'loyalty-backfill-notice';
    note.innerHTML = '<p><strong>Welcome to Rewards!</strong> We just credited <strong>'
      + backfillResult.total_points_awarded + ' points</strong> for your '
      + backfillResult.credited.length + ' previous order'
      + (backfillResult.credited.length > 1 ? 's' : '') + '.</p>';
    container.insertBefore(note, container.firstChild);

    // Auto-dismiss after 10 seconds
    setTimeout(function() {
      note.style.opacity = '0';
      setTimeout(function() { if (note.parentNode) note.parentNode.removeChild(note); }, 500);
    }, 10000);
  }

  function updateOrderPointsColumn(backfillResult) {
    if (!backfillResult) return;
    var cells = document.querySelectorAll('.js-order-points');
    cells.forEach(function(cell) {
      var orderName = cell.getAttribute('data-order-name');

      // Check credited orders
      if (backfillResult.credited) {
        for (var i = 0; i < backfillResult.credited.length; i++) {
          if (backfillResult.credited[i].order_name === orderName) {
            cell.innerHTML = '<span class="ca-orders__points">+' + backfillResult.credited[i].points + ' pts</span>';
            return;
          }
        }
      }

      // Check skipped (already credited)
      if (backfillResult.skipped) {
        for (var j = 0; j < backfillResult.skipped.length; j++) {
          if (backfillResult.skipped[j].order_name === orderName && backfillResult.skipped[j].reason === 'already_credited') {
            cell.innerHTML = '<span class="ca-orders__points ca-orders__points--credited">Credited</span>';
            return;
          }
        }
      }
    });
  }

  function updateOrderPointsFromActivity(data) {
    if (!data || !data.activity) return;
    var cells = document.querySelectorAll('.js-order-points');
    if (cells.length === 0) return;

    cells.forEach(function(cell) {
      var orderName = cell.getAttribute('data-order-name');
      var found = false;
      for (var i = 0; i < data.activity.length; i++) {
        var desc = data.activity[i].description || '';
        if (desc.indexOf(orderName) >= 0 && (data.activity[i].action === 'purchase')) {
          cell.innerHTML = '<span class="ca-orders__points">+' + data.activity[i].points + ' pts</span>';
          found = true;
          break;
        }
      }
      if (!found && data.backfilled) {
        cell.innerHTML = '<span class="ca-orders__points ca-orders__points--credited">Credited</span>';
      }
    });
  }

  function initCartBanners() {
    var banners = document.querySelectorAll('.js-loyalty-cart-banner');
    if (banners.length === 0) return;
    fetchBalance(CUSTOMER_EMAIL, function(data) {
      if (data && data.config) applyConfig(data.config);
      banners.forEach(function(banner) {
        renderCartBanner(banner, data);
      });
    });
  }

  /* ---- Referral capture on register page ---- */
  function captureReferral() {
    var params = new URLSearchParams(window.location.search);
    var refCode = params.get('ref');
    if (refCode) {
      /* Store for after registration */
      sessionStorage.setItem('mbur_referral_code', refCode);
      /* Show referral note on register form */
      var header = document.querySelector('.ca-header__subtitle');
      if (header) {
        header.innerHTML = 'You were referred by a friend! Create your account to earn <strong>50 bonus points</strong>.';
      }
    }
  }

  /* After successful registration, send referral */
  function sendReferralOnRegister() {
    var refCode = sessionStorage.getItem('mbur_referral_code');
    if (refCode && CUSTOMER_EMAIL) {
      registerReferral(CUSTOMER_EMAIL, refCode);
      sessionStorage.removeItem('mbur_referral_code');
    }
  }

  /* ---- Award review points (called from review form) ---- */
  window.__awardReviewPoints = function(email, hasPhotos) {
    if (!LOYALTY_SCRIPT_URL || !email) return;
    fetch(LOYALTY_SCRIPT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'review',
        email: email,
        has_photos: hasPhotos
      })
    }).catch(function() {});
  };

  /* ---- Boot ---- */
  document.addEventListener('DOMContentLoaded', function() {
    initDashboard();
    initCartBanners();
    captureReferral();

    /* If on account page and there's a stored referral, process it */
    if (document.querySelector('.ca-welcome') && CUSTOMER_EMAIL) {
      sendReferralOnRegister();
    }
  });

})();
